module.exports = __webpack_public_path__ + "static/media/18_plantilla_rec_combo_simple_cp_gaseosas_pet_500_fl.f8d54d13.png";